import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import MuiLink from "@mui/material/Link";

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDTypography from "common/components/MD/MDTypography";
import MDButton from "common/components/MD/MDButton";

import LogoAgri2026 from "common/assets/images/logos/logo_data_2026.png"

import UtilityService from "services/API/utility/UtilityService";
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";

function Banner_attesa_2026({ action }) {



  return (
    <Card>
      <MDBox position="relative" borderRadius="lg" mt={-3} mx={2}>

       <MDBox
          component="img"
          src={LogoAgri2026}
          alt="Agriumbria 2026"
          borderRadius="lg"
          shadow="md"
          width="100%"
          height="100%"
          position="relative"
          padding={5}
          zIndex={1}
        />

      </MDBox>
      <MDBox p={3}>
      
           <MDTypography display="inline" variant="h4" textTransform="capitalize" fontWeight="bold">
        "SAVE THE DATE!!!"
        </MDTypography>
        <MDBox mt={2} mb={3}>
          <MDTypography variant="body2" component="p" color="text">
          Benvenuto nella tua <b>Area Riservata</b>, da <b>lunedì 29 settembre 2025 </b>
          potrai compilare e presentare la tua <b>Proposta di Partecipazione</b> per Agriumbria 2026 
          direttamente da qui.
 </MDTypography> <MDTypography variant="body2" component="p" color="text">
A presto!
          </MDTypography>
        </MDBox>
        {/*action.type === "external" ? (
          <MuiLink href={action.route} target="_blank" rel="noreferrer">
            <MDButton color={action.color ? action.color : "dark"}>{action.label}</MDButton>
          </MuiLink>
      
        ) : (
          <Link to={action.route}>
            <MDButton color={action.color ? action.color : "dark"}>{action.label}</MDButton>
          </Link>

        )*/}
 
   
      <MDBox mt={2} mb={3} >    

                                                        </MDBox>
                                                        </MDBox>
    </Card>
  );
}

// Typechecking props for the SimpleBlogCard
Banner_attesa_2026.propTypes = {
   action: PropTypes.shape({
    type: PropTypes.oneOf(["external", "internal"]).isRequired,
    route: PropTypes.string.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "light",
      "default",
    ]),
    label: PropTypes.string.isRequired,
  }).isRequired,
};

export default Banner_attesa_2026;
